type ProgressChange = { userId: string; feature: string };
const listeners = new Set<(change: ProgressChange) => void>();

export function notifyProgressSaved(change: ProgressChange): void {
    listeners.forEach((listener) => listener(change));
}

export function subscribeProgressSaved(listener: (change: ProgressChange) => void): () => void {
    listeners.add(listener);
    return () => { listeners.delete(listener); };
}
